// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    supportHttp: 'https://supporter.dev-miranda.megakit.pro',
    mirandaHttp: 'https://dev-miranda.megakit.pro',
    passengerMirandaHttp: 'https://pass.dev-miranda.megakit.pro/passenger',
    driverMirandaHttp: 'https://driver.dev-miranda.megakit.pro/driver',
    dispatcherMirandaHttp: 'https://dispapp.dev-miranda.megakit.pro/dispatcher',
    cdnHttp: 'https://skynet.dev-miranda.megakit.pro',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
